import {
  HIDE_LOADING_PROGRESS,
  MENU,
  MULTI_SECTION_LIST_ACTIONS,
  SET_CURRENT_GNB,
  SET_CURRENT_MENU,
  SHOW_LOADING_PROGRESS,
} from '@/common/resources/const'
import _ from 'lodash'
import fp from 'lodash/fp'
import { GNB_EVENT_LIST } from '@/common/utils/gnb.fp'
import { fetchFromEventObject } from '@/common/utils/request.common'
const state = {
  currentMenu: MENU.HOME,
  currentGnb: MENU.HOME,
  [MENU.HOME]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.BROADCAST]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.LIVE]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.MOVIE]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.MOVIE_17]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.MOVIE_18]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.GLOBAL]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.CLIP]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.BASEBALL]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU.MY]: {
    GNBData: null,
    multiSectionList: [],
  },
  bandMemorize: {},
  isBandLoading: false,
  beforeEnterPath: '',
}
const getters = {
  multiSectionList(state) {
    return state[state.currentGnb].multiSectionList
  },
  isBandLoading(state) {
    return state.isBandLoading
  },
  currentMenu(state) {
    return state.currentMenu
  },
  currentGnb(state) {
    return state.currentGnb
  },
  currentGnbTitle(state) {
    return _.get(state, [state.currentGnb, 'GNBData', 'note'], '')
  },
}

const actions = {
  async [MULTI_SECTION_LIST_ACTIONS.FETCH](
    context,
    { gnbName = MENU.HOME, force = false },
  ) {
    context.commit(SHOW_LOADING_PROGRESS)
    const { onContent, onClick } = GNB_EVENT_LIST[gnbName]
    fetchFromEventObject(onClick) // 비동기
    const { data } = await fetchFromEventObject(onContent)
    const existGNBData = _.get(state, [gnbName, 'GNBData'], null)
    const getGenTime = fp.getOr('', 'gen_time')
    if (
      force ||
      existGNBData === null ||
      getGenTime(existGNBData) !== getGenTime(data)
    ) {
      // 기존 데이터가 없음으로 무조건 셋팅
      state[gnbName].GNBData = data
      // TODO: 특정일을 기준으로 테스트 하고 싶을때 아래 url을 변경한다.
      // if (isTestKboGNB(gnbName)) {
      //   state[gnbName].multiSectionList = _.get(data, 'multisectionlist', []).filter((multiSection) => {
      //     if (multiSection.cell_type === 'band_43') {
      //       multiSection.eventlist[1].url = 'annexapi.wavve.com/skb/baseball/teamcalendarlist-band?response_format=json&IF=IF-PORG-002&ver=2.0&m=getTeamCalendarListBand&spo_itm_cd=KBO&tgroup=B&tvalue=BC123&date=20201205'
      //       multiSection.eventlist[2].url = 'annexapi.wavve.com/skb/baseball/teamcalendarlist?response_format=json&IF=IF-PORG-002&ver=2.0&m=getTeamCalendarListBand&spo_itm_cd=KBO&tgroup=B&tvalue=BC123&date=20201205'
      //     }
      //
      //     const cellType = _.get(multiSection, 'cell_type', '')
      //     return cellType !== 'band_41' && cellType !== 'band_45'
      //   })
      // } else {
      state[gnbName].multiSectionList = _.get(data, 'multisectionlist', [])
      // }
    }
    context.commit(HIDE_LOADING_PROGRESS)
  },
}

const mutations = {
  [SET_CURRENT_MENU](state, menuName) {
    state.currentMenu = menuName
  },
  [SET_CURRENT_GNB](state, gnbName) {
    state.currentGnb = gnbName
  },
  [SHOW_LOADING_PROGRESS](state) {
    state.isLoading = true
  },
  [HIDE_LOADING_PROGRESS](state) {
    state.isLoading = false
  },
}

export default { state, getters, actions, mutations }
